import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/questions.action'
import * as fromQuestionActions from '../../../actions/questions.action'
import { createLikertQuestion } from 'api/administration/questions/Create'
import { IQuestionLikertModel } from 'models/questionLikert.model'
import { getQuestionList } from 'api/administration/questions/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { BlockTypes } from 'enum/block-type.enum'

async function getList(instanceId: number) {
  return getQuestionList(instanceId)
}

async function handleCreateLicker(
  data: IQuestionLikertModel<
    BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation
  >
) {
  return createLikertQuestion(data)
}

function* newLikertEffectSaga(action: any) {
  try {
    const {
      data: { data, instanceId },
    } = action
    yield call(handleCreateLicker, data)
    const questionList = yield call(getList, instanceId)
    yield put(fromQuestionActions.Actions.questionsListSuccess(questionList))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.createError'))
    console.log('error: ', error)
  }
}

export function* createLikertWatcherSaga() {
  yield takeLatest(fromActions.QUESTION_LIKERT_CREATE, newLikertEffectSaga)
}
